import React, { Component } from "react";
import { Field, reduxForm, FormSection, formValueSelector, reset } from "redux-form";
import axios from "axios";
import { TabContent, TabPane, Nav, NavItem, NavLink, Card, CardBody, Button, CardTitle, CardText, Row, Col, Pagination } from 'reactstrap';
import classnames from 'classnames';
import { connect } from "react-redux";
import PageSpinner from "../PageSpinner";
import Banner from "../common/banner";
import renderInput from "../common/renderinput";
import appConfig from '../../config/config';



class PropertyReportPay extends Component {


    constructor(...args) {
        super(...args);
        this.state = {
            showBanner: false, message: '', IsDataLoaded: false, OrderData: {}
        };
    }
    closeBanner = () => {
        this.setState({
            showBanner: false, message: ''
        });
    };
    submit = (values) => {
        axios.post(
            appConfig.apiGateway.updatePropertyReport,
            JSON.stringify({
                ...values, OrderId: this.props.OrderId,
                OrderProductId: this.props.OrderProductId,
                Action: "Pay",
                UserName: this.props.session.session.user.name
            }),
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.props.session.session.credentials.accessToken}`
                }
            }
        ).then((response) => {
            if (response.data.Count > 0) {
                var myObject = JSON.parse(response.data.body);
                this.props.dispatch(reset('propertyReportPayForm'))
            }
        },
            (error) => {
                this.setState(state => ({ ...state, message: error, showBanner: true }));

            });

    }
    render() {
        return (
            <>
            </>
        );
    }
}

const validate = (formValues) => {
    const errors = {};

    return errors;
}
var propertyReportPayForm = reduxForm({
    form: 'propertyReportPayForm',
    validate
})(PropertyReportPay);

propertyReportPayForm = connect(
    state => ({
        session: state.session
    })
)(propertyReportPayForm);

export default propertyReportPayForm;